var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4A4A4A",
    strokeDasharray: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.919 1.072c1.29 0 3.557-.438 3.68.847l.932 16.139a2.505 2.505 0 002.495 2.264h9.66c1.644 0 2.55 1.439 2.566 3.082.016 1.665-.901 2.903-2.566 2.903H3.511A2.51 2.51 0 011 23.797V2.538c.005-1.381.538-1.466 1.919-1.466z"
  })));
}
export default SvgSeatCover;